import { apiClient } from "lib/apiClient";

export const unarchiveDeals = async (request: string[]) => {
  const response = await apiClient.post("/deals/unarchive", request);

  return response.data;
};
